import './SectionPrice.css'
import moment from 'moment'
import { useEffect, useState } from "react";
import momentDurationFormatSetup from "moment-duration-format";
import AddressToAccount from "../../../../components/AddressToAccount";
import chainData from "../../../../chains";
import {_AuctionManager} from "../../../../abi";
momentDurationFormatSetup(moment);
// Initialize global float price for WebSocket updates (client-only)
if (typeof window !== 'undefined') {
  window.floatprice = parseFloat("1.0");
}

/**
 * SectionPrice component.
 *
 * Displays the highest bid information for an auction.
 * Shows:
 * - "Highest Bid" heading
 * - Time of bid placement (relative)
 * - Auction ending countdown
 * - High bidder address
 * - Bid amount in native token and USD
 *
 * Updates every 5 seconds via setInterval.
 *
 * @param {Object} props - Component props
 * @param {Object} props.ti - Token/item information with auctionData
 * @returns {React.ReactElement} Price display card
 */
function SectionPrice({ ti }){

  const [update, doUpdate] = useState(0);

  // Update every 5 seconds for countdown
  useEffect(() => {
    const interval = setInterval(() => {
      doUpdate(Date.now());
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // WebSocket price updates (client-only)
  useEffect(() => {
    if (typeof window !== 'undefined' && window.hasOwnProperty("genws")) {
      window.genws.onmessage = (evt) => {
        try {
          if (evt.data.includes("sgbprice")) {
            const pData = JSON.parse(evt.data);
            window.floatPrice = parseFloat(weiToEth(pData["0"]["sgbprice"]));
          }
        } catch (err) {
          console.error("error in ws listener:", err);
        }
      };
    }
  }, []);

  // Helper to convert wei to ether string
  const weiToEth = (wei: string | number) => {
    try {
      const bigIntValue = BigInt(wei);
      const ether = bigIntValue / 10n ** 18n;
      return ether.toString();
    } catch {
      return "0";
    }
  };

  // Get float price safely for SSR
  const floatPrice = typeof window !== 'undefined' ? (window.floatPrice || 1) : 1;

  return (
      <>
      { ti.hasOwnProperty("auctionData") && ti.auctionData !== null ?
      <div className="col-lg-6 mt-lg-0">
        <div className="card card-background shadow-none card-background-mask-primary">
          <div className="full-background SectionPriceBG"></div>
          <div className="card-body text-center p-3 w-100">
            <div
                className="icon icon-shape icon-sm bg-white shadow mx-auto mb-3 d-flex align-items-center justify-content-center border-radius-md">
              <i className="ni ni-diamond text-accent text-lg top-0" aria-hidden="true"></i>
            </div>
            <h5 className="text-white up mb-10p">Highest Bid</h5>
            <p>Placed: {
              moment.duration((Math.floor(Date.now()/1000) - ti.auctionData.timestamp)*1000).humanize()
            } ago<br/>
              Ending: {
                  moment.duration((ti.auctionData.finishTime-(Math.floor(Date.now()/1000)))*1000).format("DD[d] HH[h] mm[m] ss[s]")
            }</p>
            <AddressToAccount address={ti.auctionData.bidderAddress} title1={"High Bidder"} title2={"Bidder"}
            flags={"bob"}
            comment={                <div className="d-flex align-items-start ms-auto flex-column justify-content-center">
              <h6 className="author-name text-accent mb-0">{weiToEth(ti.auctionData.bidAmount)}</h6>
              <p className="mb-0 text-dark">${(parseFloat(weiToEth(ti.auctionData.bidAmount)) * floatPrice).toFixed(0)}</p>
            </div>}/>
            {/*<ul className="list-group mt-15p">*/}
            {/*  <li className="gendark border-0 d-flex align-items-center px-2 rounded-3">*/}
            {/*    */}
            {/*    /!*<NavLink to={"/profile/" + bidInfo.artist_id} className="avatar v2 mr-10">*!/*/}
            {/*    /!*  <img src={"/cache/profile/ava_" + bidInfo.artist_id} alt=" " width="40"*!/*/}
            {/*    /!*       className="aspect11 border-radius-lg shadow"/>*!/*/}
            {/*    /!*</NavLink>*!/*/}
            {/*    /!*<div className="d-flex align-items-start flex-column justify-content-center">*!/*/}
            {/*    /!*  <NavLink to={"/profile/" + highBidder_ID} className="text-decoration-none"><h6*!/*/}
            {/*    /!*      className="author-name">{highBidderName}</h6></NavLink>*!/*/}
            {/*    /!*  <NavLink className="btn btn-link autho-link text-decoration-none"*!/*/}
            {/*    /!*           to={"/profile/" + highBidder_ID}>{highBidderContact}</NavLink>*!/*/}
            {/*    /!*</div>*!/*/}

            {/*  </li>*/}
            {/*</ul>*/}
          </div>
        </div>
      </div> : null }
      </>
    )

}

export default SectionPrice;
